import { useState } from "react";
import { Search } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { age, live } from "@/lib/clinic";
import { inputCls } from "@/components/ui-kit";

export default function PatientsTable({ onOpen }) {
  const { t, view } = useApp();
  const [q, setQ] = useState("");
  const list = live(view.patients).filter((p) => !q || p.name.toLowerCase().includes(q.toLowerCase()) || (p.phone || "").includes(q) || (p.file_no || "").toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="space-y-3" data-testid="clinic-patients">
      <div className="relative"><Search className="w-4 h-4 absolute start-3 top-1/2 -translate-y-1/2 text-[#888]" /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("search_patient")} className={`${inputCls} ps-9`} data-testid="patient-search-input" /></div>
      <div className="rounded border border-[#CCCCCC] bg-white overflow-x-auto">
        <table className="w-full text-sm" data-testid="patients-table">
          <thead><tr className="bg-[#E8E8E8] text-xs"><th className="text-start py-2 px-3">{t("file_no")}</th><th className="text-start px-3">{t("name")}</th><th className="text-start px-3">{t("hr_phone")}</th><th className="text-start px-3">{t("age")}</th><th className="text-start px-3">{t("blood_type")}</th><th className="text-start px-3">{t("allergies")}</th></tr></thead>
          <tbody>
            {list.map((p) => (
              <tr key={p.id} onClick={() => onOpen(p)} className="border-t border-[#E5E5E5] hover:bg-[#E5F1FB] cursor-pointer" data-testid="patient-row">
                <td className="py-2 px-3 text-[#666]" dir="ltr">{p.file_no}</td><td className="px-3 font-bold">{p.name}</td><td className="px-3" dir="ltr">{p.phone || "—"}</td><td className="px-3">{p.birth_date ? age(p.birth_date) : "—"}</td><td className="px-3">{p.blood_type || "—"}</td><td className="px-3 text-[#C7353B]">{p.allergies}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!list.length && <p className="p-4 text-sm text-muted-foreground">{t("patients_empty")}</p>}
      </div>
    </div>
  );
}
